<template>
  <div class="flex items-center">
    <slot>
      <posts-toolbar
        :filters="filters"
        :maximize-btn="{flat: true}"
        minimized
        @update:filters="$emit('update:filters', $event)"
      />
    </slot>
    <posts-order
      :order="filters.order"
      class="q-my-sm"
      flat
      @changed="$emit('update:filters', { ...filters, order: $event })"
    />
    <pagination-mode
      :model-value="paginationMode"
      @update:modelValue="$emit('update:paginationMode', $event)"
      flat
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { PostFilters } from '@/type';
import PostsToolbar from './ResponsivePostsToolbar.vue';
import PostsOrder from './PostsOrder.vue';
import PaginationMode from './PaginationMode.vue';

export default defineComponent({
  emits: ['update:filters', 'update:paginationMode'],
  components: {
    PaginationMode,
    PostsToolbar,
    PostsOrder,
  },
  props: {
    filters: {
      type: Object as () => PostFilters,
      required: true,
    },
    paginationMode: {
      type: String,
      default: 'scroll',
    },
  },
});
</script>
